import React from 'react';
import { Share2 as ShareIcon } from 'react-feather';
import { Row, Col, Image, message } from 'antd';
import clsx from 'clsx';

import PropTypes from 'prop-types';
import copyToClipboard from 'copy-to-clipboard';
import { Typography, Button } from 'ui-kit';
import { UrlText } from 'components/UrlText';
import { getStoreLink } from 'utils/utilsV2';
import { useInIframe } from 'components/Layout/Footer';

const StoreHeader = ({ store = {} }) => {
  const inFrame = useInIframe();
  const {
    id: storeId,
    store_name: storeName,
    description,
    image,
    enterprise_info: enterpriseInfo,
  } = store;

  const { isEnabled, subdomain, isSubdomainEnabled } = enterpriseInfo ?? {};

  const storeLink = getStoreLink({
    storeId,
    isEnabled,
    subdomain,
    isSubdomainEnabled,
  });

  const shareHandler = () => {
    copyToClipboard(storeLink);
    message.success('Link copied to clipboard!');
  };

  return (
    <Row className="Store_row" justify="center">
      <Col xs={24} lg={24}>
        <div className={clsx('hc-nheader', { 'no-image': !image }, { iframe: inFrame })}>
          {image && (
            <div className="hc-nheader__image">
              <Image src={image} />
            </div>
          )}
          <Typography variant="h3" className="hc-nheader__title" rows={2}>
            {storeName}
          </Typography>
          <Typography variant="body1" className="hc-nheader__descr">
            <UrlText text={description} />
          </Typography>
          <div className="hc-nheader__share-btn">
            <Button color="primary" endIcon={<ShareIcon />} onClick={shareHandler}>
              Share
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  );
};

StoreHeader.propTypes = {
  store: PropTypes.object.isRequired,
};

export default StoreHeader;
